// StrategyBuilder — Strategy creation/edit UI (Angel One light theme)
import React, { useState } from 'react';
import ConditionEditor from './ConditionEditor';
import { ALGO_ACTIONS } from '../../../config/tradingConstants';
import { FaSave, FaTimes } from 'react-icons/fa';

export default function StrategyBuilder({ strategy, onSave, onCancel }) {
  const [form, setForm] = useState({
    name: strategy.name || '',
    action: strategy.action || 'BUY',
    conditions: strategy.conditions || [],
    instrument: strategy.instrument || null,
    productType: strategy.productType || 'INTRADAY',
    quantity: strategy.quantity || 1,
    enabled: strategy.enabled || false,
    autoExecute: strategy.autoExecute || false,
    ...strategy,
  });

  const handleSave = () => {
    if (!form.name) return;
    onSave(form);
  };

  return (
    <div className="bg-white border border-blue-200 rounded-lg shadow-sm p-5 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-900">
          {strategy.id ? 'Edit Strategy' : 'New Strategy'}
        </h3>
        <button onClick={onCancel} className="p-1 text-gray-400 hover:text-gray-600">
          <FaTimes />
        </button>
      </div>

      {/* Name & Action */}
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="text-[11px] font-medium text-gray-500 block mb-1">Strategy Name</label>
          <input
            value={form.name}
            onChange={e => setForm({ ...form, name: e.target.value })}
            placeholder="e.g., NIFTY Breakout"
            className="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 text-xs text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="text-[11px] font-medium text-gray-500 block mb-1">Action</label>
          <select
            value={form.action}
            onChange={e => setForm({ ...form, action: e.target.value })}
            className="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 text-xs text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {ALGO_ACTIONS.map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>
      </div>

      {/* Instrument & Quantity */}
      <div className="grid grid-cols-3 gap-3">
        <div>
          <label className="text-[11px] font-medium text-gray-500 block mb-1">Symbol</label>
          <input
            value={form.instrument?.symbol || ''}
            onChange={e => setForm({
              ...form,
              instrument: { ...form.instrument, symbol: e.target.value }
            })}
            placeholder="NIFTY"
            className="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 text-xs text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="text-[11px] font-medium text-gray-500 block mb-1">Token</label>
          <input
            value={form.instrument?.token || ''}
            onChange={e => setForm({
              ...form,
              instrument: { ...form.instrument, token: e.target.value }
            })}
            placeholder="99926000"
            className="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 text-xs text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="text-[11px] font-medium text-gray-500 block mb-1">Quantity</label>
          <input
            type="number"
            value={form.quantity}
            onChange={e => setForm({ ...form, quantity: parseInt(e.target.value) || 1 })}
            min="1"
            className="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 text-xs text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {/* Conditions */}
      <ConditionEditor
        conditions={form.conditions}
        onChange={conditions => setForm({ ...form, conditions })}
      />

      {/* Toggles */}
      <div className="flex items-center gap-4">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={form.enabled}
            onChange={e => setForm({ ...form, enabled: e.target.checked })}
            className="accent-blue-600"
          />
          <span className="text-xs text-gray-600">Enabled</span>
        </label>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={form.autoExecute}
            onChange={e => setForm({ ...form, autoExecute: e.target.checked })}
            className="accent-blue-600"
          />
          <span className="text-xs text-gray-600">Auto Execute Orders</span>
        </label>
      </div>

      {/* Actions */}
      <div className="flex gap-2 pt-2 border-t border-gray-100">
        <button onClick={handleSave} className="px-4 py-2 rounded-lg text-xs font-semibold bg-blue-600 text-white hover:bg-blue-700 flex items-center gap-1.5">
          <FaSave className="text-[9px]" /> Save Strategy
        </button>
        <button onClick={onCancel} className="px-4 py-2 rounded-lg text-xs font-semibold bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-200">Cancel</button>
      </div>
    </div>
  );
}
